import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import {
  currentOrganizationSelector,
  orgTariffesSelector,
  userSelector,
} from "../../store/selectors";
import "./TariffesScreen.css";
import moment from "moment";
import AppLogo from "../../assets/AppLogoBlue.svg";
import { Switch } from "@mui/material";
import uncheckedIcon from "../../assets/unchecked.svg";
import checkedIcon from "../../assets/checked.svg";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import { ReactComponent as StarIcon } from "../../assets/starIconPurple.svg";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import {
  fetchIsTrialEligible,
  fetchOrganizationsTariffes,
  fetchPublicTariffes,
} from "../../store/tariffesSlice";
import {
  cancelUserSubscription,
  createUserSubscription,
  payForSubscription,
} from "../../store/usersSlice";
import PaymentBackdrop from "../../assets/PaymentBackdrop.png";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import { ReactComponent as TBankLogo } from "../../assets/tbank_logo.svg";
import CloseButton from "../../components/CloseButton/CloseButton";
import toast from "react-hot-toast";
import useIsMobile from "../../hooks/useIsMobile";
import { updateTariffes } from "../../helpers/helpers";
import { OrbitProgress } from "react-loading-indicators";
const shownTariffesIds = [8, 11, 22];

const attributesNames = {
  available_project_count: "Проектов",
  available_space_mb: "Хранилище",
  available_user_count: "Участников",
  available_viewer_count: "Зрители",
};

const TariffesScreen = () => {
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [tariffesLoading, setTariffesLoading] = useState(false);
  const [tariffesInfo, setTariffesInfo] = useState([]);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [activeTariffIndex, setActiveTariffIndex] = useState(-1);
  const [activeOrgTariff, setActiveOrgTariff] = useState(null);
  const currentOrganizationsTariffes = useSelector(orgTariffesSelector);
  const [isTrialEligible, setIsTrialEligible] = useState(false);
  const [chosenTariff, setChosenTariff] = useState(null);
  const [isYearlyActive, setIsYearlyActive] = useState(false);
  const [additionalSpacePrice, setAdditionalSpacePrice] = useState(null);
  const [additionalUserPrice, setAdditionalUserPrice] = useState(null);
  const [additionalValues, setAdditionalValues] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    handleUpdateTariffes();
    dispatch(fetchPublicTariffes()).then((res) => {
      if (!res.error) {
        const neededTariffes = res.payload.filter((tariff) =>
          shownTariffesIds.includes(tariff.id)
        );
        setTariffesInfo(neededTariffes);
        const firstTariffAttributes = neededTariffes[0].attributes;
        const spaceAttr = firstTariffAttributes.find(
          (attr) => attr.code === "available_space_mb"
        );
        if (spaceAttr && spaceAttr.prices && spaceAttr.prices[0]) {
          setAdditionalSpacePrice(spaceAttr.prices[0]);
        }
        const usersAttr = firstTariffAttributes.find(
          (attr) => attr.code === "available_user_count"
        );
        if (usersAttr && usersAttr.prices && usersAttr.prices[0]) {
          setAdditionalUserPrice(usersAttr.prices[0]);
        }
      }
    });
    document.title = "7cut • Тарифный план";
  }, []);

  const handleUpdateTariffes = async () => {
    setTariffesLoading(true);
    await updateTariffes(user.organizations, dispatch);
    setTariffesLoading(false);
  };

  console.log(additionalSpacePrice, additionalUserPrice);

  useEffect(() => {
    const currentOrgTariff =
      currentOrganizationsTariffes[currentOrganization.id];
    if (currentOrgTariff && currentOrgTariff.id) {
      if (currentOrgTariff.plan && currentOrgTariff.plan.id === 11) {
        setActiveTariffIndex(1);
      } else if (currentOrgTariff.plan && currentOrgTariff.plan.id === 22) {
        setActiveTariffIndex(2);
      } else if (currentOrgTariff.plan && currentOrgTariff.plan.id === 8) {
        setActiveTariffIndex(0);
      } else {
        setActiveTariffIndex(3);
      }
      setActiveOrgTariff(currentOrgTariff);
    } else {
      setActiveOrgTariff(null);
      setActiveTariffIndex(-1);
    }
    dispatch(
      fetchIsTrialEligible({ organizationId: currentOrganization.id })
    ).then((res) => {
      if (!res.error) {
        setIsTrialEligible(res.payload);
      }
    });
  }, [currentOrganizationsTariffes]);

  const handleClickDecreaseAdditional = (tariffInfo, tariffAttr) => {
    let newAdditionalValues = {
      ...additionalValues,
    };
    if (
      !additionalValues[tariffInfo.id] ||
      !additionalValues[tariffInfo.id][tariffAttr.code]
    )
      return;
    const valueToSubtract =
      tariffAttr.code === "available_space_mb" ? 10240 : 1;
    if (additionalValues[tariffInfo.id]) {
      newAdditionalValues[tariffInfo.id] = {
        ...newAdditionalValues[tariffInfo.id],
        [tariffAttr.code]:
          newAdditionalValues[tariffInfo.id][tariffAttr.code] - valueToSubtract,
      };
    }
    setAdditionalValues(newAdditionalValues);
    console.log(newAdditionalValues);
  };

  const handleClickAddAdditional = (tariffInfo, tariffAttr) => {
    let newAdditionalValues = {
      ...additionalValues,
    };
    const valueToAdd = tariffAttr.code === "available_space_mb" ? 10240 : 1;
    if (additionalValues[tariffInfo.id]) {
      if (additionalValues[tariffInfo.id][tariffAttr.code]) {
        newAdditionalValues[tariffInfo.id] = {
          ...newAdditionalValues[tariffInfo.id],
          [tariffAttr.code]:
            newAdditionalValues[tariffInfo.id][tariffAttr.code] + valueToAdd,
        };
      } else {
        newAdditionalValues[tariffInfo.id] = {
          ...newAdditionalValues[tariffInfo.id],
          [tariffAttr.code]: valueToAdd,
        };
      }
    } else {
      newAdditionalValues[tariffInfo.id] = {
        [tariffAttr.code]: valueToAdd,
      };
    }
    console.log(newAdditionalValues);
    setAdditionalValues(newAdditionalValues);
  };

  const renderAttributeRow = (tariffAttr, isPopular = false, tariffInfo) => {
    if (tariffAttr.code === "reaction_pack_code") return null;
    let attrValue =
      tariffAttr.code === "allow_release_notes"
        ? tariffAttr.value
          ? "Да"
          : "Нет"
        : tariffAttr.value;
    if (tariffAttr.code === "available_space_mb") {
      let result = +attrValue;
      if (
        additionalValues[tariffInfo.id] &&
        additionalValues[tariffInfo.id][tariffAttr.code]
      ) {
        result += additionalValues[tariffInfo.id][tariffAttr.code];
      }

      if (result > 1024) {
        result = (result / 1024).toFixed(0).toString() + " Гб";
      } else {
        result += " Мб";
      }

      attrValue = result;
    }

    if (tariffAttr.code === "available_user_count") {
      let result = +attrValue;
      if (
        additionalValues[tariffInfo.id] &&
        additionalValues[tariffInfo.id][tariffAttr.code]
      ) {
        result += additionalValues[tariffInfo.id][tariffAttr.code];
      }
      attrValue = result;
    }

    if (tariffAttr.code === "available_viewer_count") {
      attrValue = "Безлимит";
    }

    const isNeedToRenderAdditionals =
      tariffInfo.id !== 8 &&
      (tariffAttr.code === "available_space_mb" ||
        tariffAttr.code === "available_user_count");

    const canSubtract =
      isNeedToRenderAdditionals &&
      additionalValues[tariffInfo.id] &&
      additionalValues[tariffInfo.id][tariffAttr.code] &&
      additionalValues[tariffInfo.id][tariffAttr.code] > 0;

    return (
      <div className={`tariff-attribute-row ${isPopular && "popular"}`}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <StarIcon
            style={{
              transform: "scale(1.7)",
              fill: isPopular ? "#333B4B" : "#F1F7FF",
            }}
            width={12}
            height={24}
          />
          <span>
            {(tariffAttr && attributesNames[tariffAttr.code]) ||
              (tariffAttr && tariffAttr.name) ||
              "..."}
            :
          </span>
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {isNeedToRenderAdditionals && (
            <div
              onClick={() =>
                handleClickDecreaseAdditional(tariffInfo, tariffAttr)
              }
              style={{
                borderRadius: 4,
                cursor: "pointer",
                border: "1px solid #E2E8F0",
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 16,
                fontWeight: 300,
                boxSizing: "border-box",
                paddingBottom: 4,
                color: canSubtract ? "#2563EB" : "#E2E8F0",
                userSelect: "none",
              }}
            >
              -
            </div>
          )}
          <span>{attrValue}</span>
          {isNeedToRenderAdditionals && (
            <div
              onClick={() => handleClickAddAdditional(tariffInfo, tariffAttr)}
              style={{
                borderRadius: 4,
                border: "1px solid #E2E8F0",
                cursor: "pointer",
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                fontSize: 16,
                fontWeight: 300,
                color: "#2563EB",
                userSelect: "none",
              }}
            >
              +
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleCancelCurrentSubscription = (tariffToCancel) => {
    if (
      confirm(
        "Вы действительно хотите отменить данный тариф для текущей организации?"
      )
    ) {
      dispatch(
        cancelUserSubscription({
          organizationId: tariffToCancel.organizationId,
          subscriptionId: tariffToCancel.id,
        })
      ).then((res) => {
        if (!res.error) {
          handleUpdateTariffes();
          toast.success(`Тариф отменен`);
        }
      });
    }
  };

  const renderOrdinaryTariff = (tariffInfo, index) => {
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");
    const monthPriceIfYearChosen = yearPrice && Math.ceil(yearPrice.price / 12);

    let additionalPrice = 0;
    if (
      tariffInfo &&
      additionalValues[tariffInfo.id] &&
      additionalValues[tariffInfo.id]["available_space_mb"]
    ) {
      let spacePrice =
        (additionalSpacePrice && additionalSpacePrice.price) || 299;

      additionalPrice +=
        (additionalValues[tariffInfo.id]["available_space_mb"] / 10240) *
        spacePrice;
    }

    if (
      tariffInfo &&
      additionalValues[tariffInfo.id] &&
      additionalValues[tariffInfo.id]["available_user_count"]
    ) {
      let userPrice = (additionalUserPrice && additionalUserPrice.price) || 999;
      additionalPrice +=
        additionalValues[tariffInfo.id]["available_user_count"] * userPrice;
    }

    if (tariffesLoading) {
      return (
        <div
          className={`${isMobile ? "tariff-item-mobile" : "tariff-item"} ${
            index === activeTariffIndex &&
            activeOrgTariff &&
            activeOrgTariff.status === "ACTIVE" &&
            "inactive"
          }`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <OrbitProgress style={{ fontSize: 12 }} color="#3496FF" />
        </div>
      );
    }

    return (
      <div
        className={`${isMobile ? "tariff-item-mobile" : "tariff-item"} ${
          index === activeTariffIndex &&
          activeOrgTariff &&
          activeOrgTariff.status === "ACTIVE" &&
          "inactive"
        }`}
      >
        {index === activeTariffIndex && (
          <div className="tariff-active-label">Текущий</div>
        )}

        <span className="tariff-item-title">{tariffInfo?.name || "..."}</span>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-end",
            gap: 5,
          }}
        >
          <span className="tariff-item-price">
            {isYearlyActive
              ? `${monthPriceIfYearChosen + additionalPrice}` + " ₽" || "..."
              : `${(monthPrice?.price || 0) + additionalPrice}` + " ₽" || "..."}
          </span>
          <span className="tariff-item-price-month" style={{ marginBottom: 3 }}>
            /мес
          </span>
        </div>
        {isYearlyActive && (
          <div
            style={{
              marginBottom: 12,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                color: "#64748B",
                fontSize: 14,
                textDecorationLine: "line-through",
              }}
            >{`${(monthPrice && monthPrice.price) || "0"}₽/мес при помесячной оплате`}</span>
            <span
              style={{
                color: "#3496ff",
                fontWeight: 500,
                fontSize: 14,
              }}
            >{`→ ${(yearPrice && yearPrice.price) || "0"}₽/год`}</span>
          </div>
        )}
        {isTrialEligible && activeTariffIndex === -1 && (
          <span
            className="tariff-item-trial"
            style={{}}
          >{`${tariffInfo && tariffInfo.id === 22 ? "15" : "30"} дней бесплатно!`}</span>
        )}
        <span className="tariff-item-description">
          {tariffInfo?.description || "..."}
        </span>
        {tariffInfo &&
          tariffInfo.attributes.map((tariffAttr) => {
            return renderAttributeRow(tariffAttr, false, tariffInfo);
          })}
        {/* <div className="tariff-item-all-list">Посмотреть все функции</div> */}
        <div style={{ flex: 1 }} />
        <div
          className={`tariff-try-button ${
            index === activeTariffIndex &&
            activeOrgTariff &&
            (activeOrgTariff.status === "ACTIVE" ||
              activeOrgTariff.status === "TRIALING") &&
            "inactive"
          }`}
          onClick={() => {
            if (
              index === activeTariffIndex &&
              (activeOrgTariff.status === "ACTIVE" ||
                activeOrgTariff.status === "TRIALING")
            )
              return;
            setChosenTariff(tariffInfo);
            if (
              index === activeTariffIndex &&
              activeOrgTariff &&
              activeOrgTariff.status === "UNPAID"
            ) {
              handlePayForExistingSubscription(activeOrgTariff);
              return;
            }
            if (activeTariffIndex < 0 && isTrialEligible) {
              handleStartTrialing(tariffInfo);
              return;
            }
            setIsPaymentModalVisible(true);
          }}
        >
          {isTrialEligible && activeTariffIndex === -1
            ? "Начать бесплатный период"
            : index === activeTariffIndex
              ? `Активен${activeOrgTariff && activeOrgTariff.status === "TRIALING" ? " (триал)" : activeOrgTariff && activeOrgTariff.status === "UNPAID" ? " (необходима оплата)" : ""}`
              : "Перейти"}
        </div>
        {index === activeTariffIndex && (
          <div
            className={`tariff-try-button`}
            style={{
              background: "transparent",
              border: "1px solid white",
              color: "white",
            }}
            onClick={() => {
              handleCancelCurrentSubscription(activeOrgTariff);
            }}
          >
            Отменить
          </div>
        )}
      </div>
    );
  };

  const handlePayForExistingSubscription = (tariffToPay) => {
    dispatch(
      payForSubscription({
        organizationId: tariffToPay.organizationId,
        subscriptionId: tariffToPay.id,
      })
    ).then((res) => {
      if (!res.error) {
        const link = res.payload.paymentLink;
        if (link) {
          window.location.href = link;
        }
      } else {
        toast.error(res.payload);
      }
    });
  };

  const renderPopularTariff = (tariffInfo, index) => {
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");

    let additionalPrice = 0;
    if (
      tariffInfo &&
      additionalValues[tariffInfo.id] &&
      additionalValues[tariffInfo.id]["available_space_mb"]
    ) {
      let spacePrice =
        (additionalSpacePrice && additionalSpacePrice.price) || 299;

      additionalPrice +=
        (additionalValues[tariffInfo.id]["available_space_mb"] / 10240) *
        spacePrice;
    }

    if (
      tariffInfo &&
      additionalValues[tariffInfo.id] &&
      additionalValues[tariffInfo.id]["available_user_count"]
    ) {
      let userPrice = (additionalUserPrice && additionalUserPrice.price) || 999;
      additionalPrice +=
        additionalValues[tariffInfo.id]["available_user_count"] * userPrice;
    }

    const monthPriceIfYearChosen = yearPrice && Math.ceil(yearPrice.price / 12);

    if (tariffesLoading) {
      return (
        <div
          className={`${
            isMobile ? "tariff-item-popular-mobile" : "tariff-item-popular"
          }`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <OrbitProgress style={{ fontSize: 12 }} color="#3496FF" />
        </div>
      );
    }

    return (
      <div
        className={`${
          isMobile ? "tariff-item-popular-mobile" : "tariff-item-popular"
        }`}
      >
        {index === activeTariffIndex && (
          <div className="tariff-active-label-popular">Текущий</div>
        )}
        {index !== activeTariffIndex && (
          <div className="tariff-popular-label">Популярный</div>
        )}
        <div
          style={{
            paddingLeft: 15,
            paddingRight: 15,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <span className="tariff-item-title">{tariffInfo?.name || "..."}</span>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              gap: 5,
            }}
          >
            <span className="tariff-item-price">
              {isYearlyActive
                ? `${monthPriceIfYearChosen + additionalPrice}` + " ₽" || "..."
                : `${(monthPrice?.price || 0) + additionalPrice}` + " ₽" ||
                  "..."}
            </span>
            <span
              className="tariff-item-price-month"
              style={{ marginBottom: 3 }}
            >
              /мес
            </span>
          </div>
          {isYearlyActive && (
            <div
              style={{
                marginBottom: 12,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "#64748B",
                  fontSize: 14,
                  textDecorationLine: "line-through",
                }}
              >{`${(monthPrice && monthPrice.price) || "0"}₽/мес при помесячной оплате`}</span>
              <span
                style={{
                  color: "#3496ff",
                  fontWeight: 500,
                  fontSize: 14,
                }}
              >{`→ ${(yearPrice && yearPrice.price) || "0"}₽/год`}</span>
            </div>
          )}
          {isTrialEligible && activeTariffIndex === -1 && (
            <span
              className="tariff-item-trial"
              style={{}}
            >{`${tariffInfo?.prices[0].trialDays} дней бесплатно!`}</span>
          )}
        </div>
        <span className="tariff-item-description popular">
          {tariffInfo?.description || "..."}
        </span>
        <div style={{ flex: 1 }} />
        <div className="tariff-item-popular-backdrop">
          {tariffInfo &&
            tariffInfo.attributes.map((tariffAttr) => {
              return renderAttributeRow(tariffAttr, true, tariffInfo);
            })}
          {/* <div className="tariff-item-all-list">Посмотреть все функции</div> */}
          {/* <div style={{ flex: 1 }} /> */}
          <div
            className={`tariff-try-button ${
              index === activeTariffIndex &&
              activeOrgTariff &&
              activeOrgTariff.status === "ACTIVE" &&
              "inactive"
            }`}
            onClick={() => {
              if (
                index === activeTariffIndex &&
                activeOrgTariff &&
                activeOrgTariff.status === "ACTIVE"
              )
                return;
              setChosenTariff(tariffInfo);
              if (
                index === activeTariffIndex &&
                activeOrgTariff &&
                activeOrgTariff.status === "UNPAID"
              ) {
                handlePayForExistingSubscription(activeOrgTariff);
                return;
              }
              if (activeTariffIndex < 0 && isTrialEligible) {
                handleStartTrialing(tariffInfo);
                return;
              }
              setIsPaymentModalVisible(true);
              // const price = isYearlyActive ? yearPrice : monthPrice;
              // if (index !== activeTariffIndex) {
              //   dispatch(
              //     createUserSubscription({
              //       organizationId: currentOrganization.id,
              //       subscriptionData: {
              //         planVersionPriceId: price.id,
              //       },
              //     })
              //   ).then((res) => {
              //     if (!res.error) {
              //       const link = res.payload.payment.paymentLink;
              //       window.location.href = link;
              //     }
              //   });
              // }
            }}
          >
            {isTrialEligible && activeTariffIndex === -1
              ? "Начать бесплатный период"
              : index === activeTariffIndex
                ? `Активен${activeOrgTariff && activeOrgTariff.status === "TRIALING" ? " (триал)" : activeOrgTariff && activeOrgTariff.status === "UNPAID" ? " (необходима оплата)" : ""}`
                : "Перейти"}
          </div>
          {index === activeTariffIndex && (
            <div
              className={`tariff-try-button`}
              style={{
                background: "transparent",
                border: "1px solid #427fff",
                color: "#427fff",
              }}
              onClick={() => {
                handleCancelCurrentSubscription(activeOrgTariff);
              }}
            >
              Отменить
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderTariffesRow = () => {
    return (
      <div className={isMobile ? "tariffes-row-mobile" : "tariffes-row"}>
        {renderOrdinaryTariff(tariffesInfo[0], 0)}
        {renderPopularTariff(tariffesInfo[1], 1)}
        {renderOrdinaryTariff(tariffesInfo[2], 2)}
      </div>
    );
  };

  const renderPaymentTariffInfo = (tariffInfo) => {
    if (tariffInfo.id !== chosenTariff.id) {
      return null;
    }
    const monthPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      tariffInfo &&
      tariffInfo.prices.find((price) => price.periodUnit === "YEAR");
    const isChosenTariff = chosenTariff.id === tariffInfo.id;
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: isChosenTariff ? "#717B8E50" : "transparent",
          border: isChosenTariff ? "1px solid #3496FF" : "1px solid #717B8E",
          borderRadius: 40,
          boxSizing: "border-box",
          cursor: "pointer",
          padding: 20,
          paddingTop: 15,
        }}
        onClick={() => setChosenTariff(tariffInfo)}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {isChosenTariff ? (
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: "#3496FF",
                  border: "1px solid #3496FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 11,
                    height: 11,
                    borderRadius: 10,
                    backgroundColor: "transparent",
                    border: "3px solid #383c43",
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: "transparent",
                  border: "1px solid #717B8E",
                }}
              />
            )}
            <span
              style={{
                marginLeft: 10,
                fontSize: 24,
                fontWeight: 500,
                color: isChosenTariff ? "#3496FF" : "#C1C7D4",
              }}
            >
              {tariffInfo.name}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
            }}
          >
            <span
              style={{
                fontSize: 24,
                fontWeight: 500,
                color: isChosenTariff ? "#FFFCFC" : "#C1C7D4",
              }}
            >{`${
              isYearlyActive
                ? yearPrice?.price || "0"
                : monthPrice?.price || "0"
            } ₽`}</span>
            <span
              style={{
                color: "#c1c7d4",
                fontWeight: 500,
                fontSize: 14,
                marginBottom: 3,
              }}
            >
              {isYearlyActive ? "/год" : "/мес"}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
            justifyContent: "flex-start",
            boxSizing: "border-box",
            marginTop: 10,
          }}
        >
          <span
            style={{
              fontSize: 14,
              fontWeight: 500,
              textAlign: "left",
              color: isChosenTariff ? "#C1C7D4" : "#717B8E",
            }}
          >
            {tariffInfo.description}
          </span>
        </div>
      </div>
    );
  };

  const handleStartTrialing = (chosenTariffInfo) => {
    const monthPrice =
      chosenTariffInfo &&
      chosenTariffInfo.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      chosenTariffInfo &&
      chosenTariffInfo.prices.find((price) => price.periodUnit === "YEAR");

    const price = isYearlyActive ? yearPrice : monthPrice;

    const trialDays = price.trialDays;

    const trialStartDate = moment().format("YYYY-MM-DD");

    const trialEndDateObject = moment().add(trialDays, "days");
    const trialEndDate = trialEndDateObject.format("YYYY-MM-DD");
    dispatch(
      createUserSubscription({
        organizationId: currentOrganization.id,
        subscriptionData: {
          planVersionPriceId: price.id,
        },
        trialStartDate,
        trialEndDate,
        status: "TRIALING",
      })
    ).then((res) => {
      if (!res.error) {
        if (
          res.payload &&
          res.payload.subscription &&
          res.payload.subscription.status === "UNPAID"
        ) {
          handleUpdateTariffes();
          toast.error(
            `Вы уже использовали бесплатный период для текущей организации! Оплатите тариф, чтобы продолжить им пользоваться`
          );
        } else if (
          res.payload &&
          res.payload.subscription &&
          res.payload.subscription.status === "TRIALING"
        ) {
          toast.success(
            `Ваш бесплатный период активирован до ${trialEndDateObject.format("DD.MM.YYYY")}`
          );
          navigate("/home");
        }
      } else {
        toast.error("Произошла ошибка");
      }
    });
  };

  const handleConfirmPayment = () => {
    if (!isChecked || isLoading) return;
    setIsLoading(true);
    const monthPrice =
      chosenTariff &&
      chosenTariff.prices.find((price) => price.periodUnit === "MONTH");
    const yearPrice =
      chosenTariff &&
      chosenTariff.prices.find((price) => price.periodUnit === "YEAR");
    const price = isYearlyActive ? yearPrice : monthPrice;

    let formData = {
      organizationId: currentOrganization.id,
      subscriptionData: {
        planVersionPriceId: price.id,
      },
    };

    if (chosenTariff && additionalValues[chosenTariff.id]) {
      let additionalResources = [];
      let megabytesToAddQuantity = 0;
      let usersToAddQuantity = 0;
      if (additionalValues[chosenTariff.id]["available_space_mb"]) {
        const neededAttribute = chosenTariff.attributes.find(
          (attr) => attr.code === "available_space_mb"
        );
        let additionalSpacePrice = neededAttribute.prices[0];
        megabytesToAddQuantity =
          additionalValues[chosenTariff.id]["available_space_mb"] / 10240;
        additionalResources.push({
          planVersionAttributeId: neededAttribute.id,
          planVersionAttributePriceId: additionalSpacePrice.id,
          quantity: megabytesToAddQuantity,
        });
      }
      if (additionalValues[chosenTariff.id]["available_user_count"]) {
        const neededAttribute = chosenTariff.attributes.find(
          (attr) => attr.code === "available_user_count"
        );
        let additionalUserPrice = neededAttribute.prices[0];
        usersToAddQuantity =
          additionalValues[chosenTariff.id]["available_user_count"];
        additionalResources.push({
          planVersionAttributeId: neededAttribute.id,
          planVersionAttributePriceId: additionalUserPrice.id,
          quantity: usersToAddQuantity,
        });
      }
      formData = {
        ...formData,
        subscriptionData: {
          ...formData.subscriptionData,
          additionalResources,
        },
      };
    }

    dispatch(createUserSubscription(formData)).then((res) => {
      if (!res.error) {
        setIsLoading(false);
        const link = res.payload.payment.paymentLink;
        if (link) {
          window.location.href = link;
        }
      } else {
        toast.error(res.payload);
        setIsLoading(false);
      }
    });
  };

  const getPaymentTitle = () => {
    return (
      <>
        <span className="payment-title">Подключение тарифа</span>
        <div>
          <span className="payment-title" style={{ color: "#3496FF" }}>
            {chosenTariff.name}
          </span>
          <span className="payment-title">{` с ${
            isYearlyActive ? "ежегодной" : "ежемесячной"
          } оплатой`}</span>
        </div>
        <div>
          <span className="payment-title">на аккаунт</span>
          <span
            className="payment-title"
            style={{ color: "#717B8E" }}
          >{` ${user.email}`}</span>
        </div>
      </>
    );
  };

  const getAdditionalSpaceTitle = () => {
    let result = "Без дополнительного места в хранилище";

    if (
      additionalValues[chosenTariff.id] &&
      additionalValues[chosenTariff.id]["available_space_mb"]
    ) {
      const price = (additionalSpacePrice && additionalSpacePrice.price) || 299;
      const additionalSpace =
        additionalValues[chosenTariff.id]["available_space_mb"] / 1024;
      result = `+ ${additionalSpace}Гб дополнительного места в хранилище (${(additionalSpace / 10) * price} ₽/мес)`;
    }

    return result;
  };

  const declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  };

  const getAdditionalUsersTitle = () => {
    let result = "Без дополнительных участников";

    if (
      additionalValues[chosenTariff.id] &&
      additionalValues[chosenTariff.id]["available_user_count"]
    ) {
      const price = (additionalUserPrice && additionalUserPrice.price) || 100;
      const additionalUsers =
        additionalValues[chosenTariff.id]["available_user_count"];
      result = `+ ${additionalUsers} ${declOfNum(additionalUsers, ["дополнительный участник", "дополнительных участника", "дополнительных участников"])} (${additionalUsers * price} ₽/мес)`;
    }

    return result;
  };

  if (isPaymentModalVisible) {
    return (
      <div className="App">
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            zIndex: 1,
          }}
        >
          <img
            src={PaymentBackdrop}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            padding: "20px 19px",
          }}
        >
          <div
            className={"mainScreenHeader"}
            style={{
              backgroundColor: "transparent",
              width: "95.4%",
            }}
          >
            <div className="header-left">
              <div
                onClick={() => navigate("/home", { replace: true })}
                className={"mainScreen-logoBlock"}
                style={{ cursor: "pointer" }}
              >
                <img src={AppLogo} style={{ height: "100%" }} alt="logo" />
              </div>
            </div>
            <div className="header-actions">
              <NotificationsPopup />
              <ProfilePopup />
            </div>
          </div>
          <div
            style={{
              flex: 1,
              height: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",

              marginRight: 33,
            }}
          >
            <div
              style={{
                width: 650,
                backgroundColor: "#1F242E",
                borderRadius: 50,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                boxSizing: "border-box",
                padding: 48,
                paddingTop: 48,
                paddingBottom: 32,
              }}
            >
              <CloseButton onClose={() => setIsPaymentModalVisible(false)} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                {getPaymentTitle()}
              </div>
              {/* <div
                style={{
                  width: "70%",
                  height: 42,
                  backgroundColor: "#333B4B",
                  display: "flex",
                  flexDirection: "row",
                  borderRadius: 80,
                  cursor: "pointer",
                  marginTop: 28,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    borderTopLeftRadius: 80,
                    borderBottomLeftRadius: 80,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: "pointer",
                    justifyContent: "center",
                    color: isYearlyActive ? "#C1C7D4" : "#F1F7FF",
                    background: isYearlyActive
                      ? "#333B4B"
                      : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  }}
                  onClick={() => setIsYearlyActive(false)}
                >
                  Ежемесячно
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderTopRightRadius: 80,
                    borderBottomRightRadius: 80,
                    fontSize: 14,
                    fontWeight: 500,
                    color: !isYearlyActive ? "#C1C7D4" : "#F1F7FF",
                    background: !isYearlyActive
                      ? "#333B4B"
                      : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  }}
                  onClick={() => setIsYearlyActive(true)}
                >
                  Ежегодно
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "-25%",
                    right: 20,
                    padding: "2px 7px",
                    borderRadius: 20,
                    color: "#427FFF",
                    backgroundColor: "#F1F7FF",
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  Выгода 25%
                </div>
              </div> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  width: "100%",
                  marginTop: 20,
                }}
              >
                {tariffesInfo.map((tariffInfo) =>
                  renderPaymentTariffInfo(tariffInfo)
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  color: "#f1f7ff",
                  fontWeight: 14,
                  width: "100%",
                  textAlign: "left",
                  marginTop: 16,
                }}
              >
                {getAdditionalSpaceTitle()}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  color: "#f1f7ff",
                  fontWeight: 14,
                  width: "100%",
                  textAlign: "left",
                  marginTop: 16,
                }}
              >
                {getAdditionalUsersTitle()}
              </div>
              <div style={{ flex: 1 }} />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: 48,
                  cursor: "pointer",
                }}
                onClick={() => setIsChecked(!isChecked)}
              >
                <img
                  src={isChecked ? checkedIcon : uncheckedIcon}
                  alt="options"
                  style={{
                    width: 24,
                    height: 24,
                  }}
                />
                <span
                  style={{
                    color: "#717B8E",
                    textAlign: "left",
                    fontSize: 14,
                    marginLeft: 10,
                    fontWeight: 500,
                  }}
                >
                  Нажимая кнопку вы разрешаете компании 7cut взимать с вас плату
                  в соответствии с условиями, пока не отмените подписку
                </span>
              </div>
              <div
                style={{
                  width: "100%",
                  height: 54,
                  borderRadius: 80,
                  background:
                    "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#F1F7FF",
                  fontSize: 16,
                  opacity: isLoading || !isChecked ? 0.7 : 1,
                  marginTop: 16,
                  cursor: "pointer",
                  fontWeight: 500,
                }}
                onClick={() => handleConfirmPayment()}
              >
                {isLoading ? "Готовим ваш тариф..." : "Подключить тариф"}
                <TBankLogo
                  style={{ height: "50%", marginLeft: 20, marginTop: 5 }}
                />
              </div>
              <span
                style={{
                  color: "#717B8E",
                  textAlign: "left",
                  fontSize: 14,
                  width: "100%",
                  marginTop: 15,
                  fontWeight: 500,
                }}
              >
                {`Услуга оказывается ООО «НОЯБРЬ МЕДИА»`}
              </span>
              <span
                style={{
                  color: "#717B8E",
                  textAlign: "left",
                  fontSize: 14,
                  width: "100%",
                  fontWeight: 500,
                }}
              >
                {"ИНН 5260455584 · ОГРН 1185275033954 · Нижний Новгород"}
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  fontSize: 14,
                  fontWeight: 500,
                  alignSelf: "flex-start",
                  color: "#717B8E",
                }}
              >
                <span>При возникновении вопросов</span>{" "}
                <div
                  style={{ marginLeft: 5, color: "#3496FF", cursor: "pointer" }}
                  onClick={() => navigate("/support")}
                >
                  обратитесь в поддержку
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={isMobile ? "App-mobile" : "App"}
      style={{ overflowY: "scroll" }}
    >
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "100%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div
        className={
          isMobile ? "tariffes-container-mobile" : "tariffes-container"
        }
        style={{ alignItems: "flex-start" }}
      >
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="tariffes" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main className={isMobile ? "tariffes-main-mobile" : "tariffes-main"}>
          <div
            className={
              isMobile ? "tariffes-title-block-mobile" : "tariffes-title-block"
            }
          >
            <span
              className="tariffes-title"
              style={{ width: "100%", textAlign: "center" }}
            >
              Тарифы под любой масштаб
            </span>
          </div>
          <span
            className="tariffes-title"
            style={{
              width: "100%",
              textAlign: "center",
              fontWeight: 400,
              fontSize: 16,
              marginBottom: 16,
            }}
          >
            Выберите план — и начните работу вот прямо сейчас
          </span>
          <div
            className={
              isMobile
                ? "tariffes-switch-block-mobile"
                : "tariffes-switch-block"
            }
          >
            <div className="tariffes-switch-block-top">
              <span
                className="tariffes-switch-label"
                style={{ color: "#c4c4c4" }}
              >
                Помесячно
              </span>
              <Switch
                sx={{
                  "&.MuiSwitch-root .MuiSwitch-switchBase": {
                    color: "#F1F7FF",
                    "&.Mui-checked": {
                      "& + .MuiSwitch-track": {
                        opacity: 1,
                        backgroundColor: "#3496FF",
                      },
                    },
                  },

                  "&.MuiSwitch-root .Mui-checked": {
                    color: "#F1F7FF",
                  },
                  "&.MuiSwitch-root .MuiSwitch-track": {
                    opacity: 0.5,
                    backgroundColor: "#b7d1dc",
                  },
                  ".Mui-checked .MuiSwitch-track": {
                    opacity: 0.5,
                    backgroundColor: "red",
                  },
                }}
                slotProps={{ input: { "aria-label": "controlled" } }}
                checked={isYearlyActive}
                onChange={(e) => setIsYearlyActive(!isYearlyActive)}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 8,
                  alignItems: "center",
                }}
              >
                <span className="tariffes-switch-label">Ежегодно</span>
                <div
                  style={{
                    padding: "2px 8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#16A34A",
                    borderRadius: 10,
                    backgroundColor: "#DCFCE7",
                    fontWeight: 700,
                    fontSize: 12,
                    textTransform: "uppercase",
                    letterSpacing: ".04em",
                    marginTop: 1,
                  }}
                >
                  -15%
                </div>
              </div>
            </div>
          </div>
          {renderTariffesRow()}
          <div
            className="tariffes-additionals-block"
            style={{
              marginTop: 36,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              gap: 20,
              flexDirection: "column",
              width: "100%",
              border: "1px solid transparent",
              borderRadius: 8,
              boxSizing: "border-box",
              padding: 20,
            }}
          >
            <span style={{ fontSize: 17, fontWeight: 700, color: "#fffcfc" }}>
              Дополнительные ресурсы (в тарифах Про и Солидность 100%)
            </span>
            <div
              style={{
                flex: 1,
                minHeight: 50,
                width: "100%",
                display: "flex",
                flexDirection: "row",
                gap: 14,
              }}
            >
              <div
                style={{
                  flex: 1,
                  minHeight: 60,
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxSizing: "border-box",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid transparent",
                  background:
                    "linear-gradient(#1f242e, #1f242e) padding-box, linear-gradient(236.88deg, #7c828b 19.97%, #616161 76.98%)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    style={{ fontSize: 14, fontWeight: 400, color: "#f1f7ff" }}
                  >
                    Дополнительный участник
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#86888b",
                      marginTop: 3,
                    }}
                  >
                    Добавляется к участникам тарифа
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                      color: "#fffcfc",
                    }}
                  >
                    999 ₽/мес
                  </span>
                </div>
              </div>
              <div
                style={{
                  flex: 1,
                  minHeight: 60,
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxSizing: "border-box",
                  padding: 10,
                  borderRadius: 8,
                  border: "1px solid transparent",
                  background:
                    "linear-gradient(#1f242e, #1f242e) padding-box, linear-gradient(236.88deg, #7c828b 19.97%, #616161 76.98%)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    style={{ fontSize: 14, fontWeight: 400, color: "#f1f7ff" }}
                  >
                    Дополнительное хранилище
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#86888b",
                      marginTop: 3,
                    }}
                  >
                    Шаг 10 ГБ
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 500,
                      color: "#fffcfc",
                    }}
                  >
                    299 ₽/10 ГБ
                  </span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TariffesScreen;
